import { $authHost } from ".."

export const addSupplierContactAPI = async (supplierContact) => {
    const {data} = await $authHost.post(`api/supplier_contacts/`, supplierContact)
    return data
}

export const editSupplierContactAPI = async (supplierContact) => {
    const {data} = await $authHost.post(`api/supplier_contacts/${supplierContact.id}`, supplierContact)
    return data
}